import { VerticalNavBarContainer } from '@seller-hermes/features/ui/VerticalNavBar';
import styled from 'styled-components';

export const NavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;

  ${VerticalNavBarContainer} {
    position: sticky;
    min-height: 100vh;
    flex-shrink: 0;
    left: 0;
    top: 0;
  }
`;

export const RoutePlanningWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  > div {
    flex: 1;
    height: auto;
  }
`;

export const DeliveriesWrapper = styled.div`
  flex: 1;
  display: flex;
  & > div:first-child {
    flex: 1;
    height: unset;
  }
`;

export const UsersWrapper = styled.div`
  flex: 1;
  display: flex;
`;

export const DriverWrapper = styled.div`
  display: flex;
  background-color: ${(p) => p.theme.bg};
  width: 100%;
  ${(p) => p.theme.customScroll(p.theme)}
`;

export const DriverManagementWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.white};
`;

export const DriverPageHeader = styled.header``;
export const DriverPageTitle = styled.h1``;
